import React from 'react';
import styled from 'styled-components';
import { SmallSectionHeading } from '@99designs/emu';
import { colors, spaces, typography } from '@99designs/emu/settings';
import { Pill, PillGroup } from '@99designs/spa-common';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: ${spaces['0.25bu']};
`;

const Title = styled(SmallSectionHeading)`
    font-size: ${typography.typeScale.size3};
    margin: ${spaces['1bu']} 0 ${spaces['0.5bu']};
`;

export default function PillContainer({ title, items }: { title?: string; items: string[] }) {
    return (
        <Wrapper>
            {title && <Title>{title}</Title>}
            <PillGroup>
                {items.map((item) => (
                    <Pill key={item} color={colors.grey800}>
                        {item}
                    </Pill>
                ))}
            </PillGroup>
        </Wrapper>
    );
}
